import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { http } from 'wagmi'
import type { HttpTransport } from 'viem'
import { mainnet, sepolia, bsc, bscTestnet } from 'wagmi/chains'
import { supportedChains, isWeb3Testnet, web3NetworkMode } from './chains'

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || ''

if (import.meta.env.DEV && !projectId) {
  console.warn(
    '[web3] VITE_WALLETCONNECT_PROJECT_ID 未配置，WalletConnect / 扫码钱包不可用。请在 https://cloud.walletconnect.com 创建项目并写入 .env',
  )
}

function transport(url: string | undefined): HttpTransport {
  return url ? http(url) : http()
}

/** 按环境只注册当前模式需要的 RPC */
const transports: Record<number, HttpTransport> = isWeb3Testnet
  ? {
      [sepolia.id]: transport(import.meta.env.VITE_RPC_ETH_SEPOLIA),
      [bscTestnet.id]: transport(import.meta.env.VITE_RPC_BSC_TESTNET),
    }
  : {
      [mainnet.id]: transport(import.meta.env.VITE_RPC_ETH_MAINNET),
      [bsc.id]: transport(import.meta.env.VITE_RPC_BSC_MAINNET),
    }

export const wagmiConfig = getDefaultConfig({
  appName: import.meta.env.VITE_APP_TITLE ?? 'vite-admin',
  projectId: projectId,
  chains: [...supportedChains],
  ssr: false,
  transports,
})

export { web3NetworkMode, isWeb3Testnet }
